/* Helpers carrito 1925 + Dawn — ver también script en sections/header-1925.liquid */
const CART_DRAWER_TRIGGER_SELECTORS_LOCAL =
  'a.header-1925__cart-link, a.header-1925-floating-cart, a.header-1925-floating-trigger--cart, a.pdp-cart-floating, a#cart-icon-bubble-mobile, a#cart-icon-bubble, a#cart-icon-bubble-desktop';

function findCartDrawerTrigger(target) {
  return (
    target.closest(
      'a.header-1925__cart-link, a.header-1925-floating-cart, a.header-1925-floating-trigger--cart, a.pdp-cart-floating, a#cart-icon-bubble-mobile, a#cart-icon-bubble, a#cart-icon-bubble-desktop'
    ) ||
    target.closest('.header-1925__cart-count, .header-1925-floating-cart__count, .pdp-cart-counter')?.closest('a')
  );
}

function is1925CartCountElementLocal(element) {
  return (
    element &&
    (element.classList.contains('header-1925__cart-count') ||
      element.classList.contains('header-1925-floating-cart__count') ||
      element.classList.contains('pdp-cart-counter'))
  );
}

function getCartIconBubbleRenderTargetLocal() {
  const bubble =
    (typeof getActive1925CartCountElement === 'function' && getActive1925CartCountElement()) ||
    document.getElementById('cart-icon-bubble');

  if (is1925CartCountElementLocal(bubble)) {
    return {
      id: 'cart-icon-bubble-1925',
      section: 'cart-icon-bubble-1925',
      selector: null,
      domId: bubble.id,
    };
  }

  return {
    id: 'cart-icon-bubble',
    section: 'cart-icon-bubble',
    selector: '.shopify-section',
    domId: 'cart-icon-bubble',
  };
}

function sync1925CartCountBubblesLocal(countText) {
  if (typeof sync1925CartCountBubbles === 'function') {
    sync1925CartCountBubbles(countText);
    return;
  }

  const text = countText == null ? '' : String(countText).trim();
  document.querySelectorAll('.header-1925__cart-count, .header-1925-floating-cart__count, .pdp-cart-counter, #CartCounterBubble').forEach((el) => {
    el.textContent = text;
    const count = parseInt(text, 10);
    if (!isNaN(count) && count >= 10) {
      el.setAttribute('data-cart-wide', '');
    } else {
      el.removeAttribute('data-cart-wide');
    }
  });
  if (typeof sync1925FloatingCartVisibility === 'function') {
    sync1925FloatingCartVisibility(text);
  }
}

let cartDrawerDelegatedClickBound = false;

function bindCartDrawerDelegatedClick(cartDrawer) {
  if (cartDrawerDelegatedClickBound) return;
  cartDrawerDelegatedClickBound = true;

  document.addEventListener(
    'click',
    (event) => {
      if (!document.querySelector('cart-drawer')) return;

      const cartLink = findCartDrawerTrigger(event.target);
      if (!cartLink) return;

      event.preventDefault();
      event.stopPropagation();
      cartDrawer.open(cartLink);
    },
    true
  );
}

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    const overlay = this.querySelector('#CartDrawer-Overlay');
    if (overlay) overlay.addEventListener('click', this.close.bind(this));
  }

  connectedCallback() {
    bindCartDrawerDelegatedClick(this);
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartDrawer = this;

    document.querySelectorAll(CART_DRAWER_TRIGGER_SELECTORS_LOCAL).forEach((cartLink) => {
      if (cartLink.dataset.cartDrawerBound === 'true') return;

      cartLink.dataset.cartDrawerBound = 'true';
      cartLink.setAttribute('role', 'button');
      cartLink.setAttribute('aria-haspopup', 'dialog');

      cartLink.addEventListener('click', (event) => {
        event.preventDefault();
        cartDrawer.open(cartLink);
      });
      cartLink.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          cartDrawer.open(cartLink);
        }
      });
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const domId = section.domId || section.id;
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(domId);

      if (!sectionElement) return;
      const sectionHtml = parsedState.sections[section.section || section.id];
      if (!sectionHtml) return;

      sectionElement.innerHTML = this.getSectionInnerHTML(sectionHtml, section.selector);

      if (section.id === 'cart-icon-bubble' || section.id === 'cart-icon-bubble-1925') {
        sync1925CartCountBubblesLocal(sectionElement.textContent);
      }
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const target = selector ? parsed.querySelector(selector) : parsed.body;
    return target ? target.innerHTML : '';
  }

  getSectionsToRender() {
    const cartIcon = getCartIconBubbleRenderTargetLocal();
    return [
      {
        id: 'cart-drawer',
        section: 'cart-drawer',
        selector: '#CartDrawer',
      },
      cartIcon,
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    const cartIcon = getCartIconBubbleRenderTargetLocal();
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: cartIcon.id,
        section: cartIcon.section,
        selector: cartIcon.selector,
        domId: cartIcon.domId,
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
